// Hideo - state of the Sources page (src/pages/SourcesPage.vue) that outlives the page: the open tile (a category) and
// the search text (kept while moving between pages, like before). The tag row's filter is TAGSTATE.src.filter
// (src/stores/tags.ts, kept by rename and delete in the tag lists), so a new source (create button, dropped link, "Add")
// starts with that tag and with the open category. renderAll keeps both valid even when the page is not shown.
import { defineStore } from 'pinia'
import { ref } from 'vue'
import type { ProfileData } from '../data/types'
import { isKindTab, sourcesView, validTab } from '../features/sources'
import { TAG_NONE } from '../features/tags'
import { useTagStore } from './tags'

export const useSourcesStore = defineStore('sources', () => {
  const tags = useTagStore()
  /** '' = closed, SRC_ALL, SRC_NONE or a category id (src/features/sources.ts) */
  const tab = ref('')
  const query = ref('')

  /** A tag no longer in the bar goes back to "All"; a category without sources (after the tag filter) closes */
  function sync(d: ProfileData, active: string): void {
    const v = sourcesView(d, active, tags.state.src.filter)
    if (v.tag !== tags.state.src.filter) tags.state.src.filter = v.tag
    const tb = validTab(v, tab.value)
    if (tb !== tab.value) tab.value = tb
  }
  /** What a new source starts with: the tag of the row (not "No tag") and the open category */
  const newSourceTag = (): string => (tags.state.src.filter === TAG_NONE ? '' : tags.state.src.filter)
  const newSourceKind = (): string => (isKindTab(tab.value) ? tab.value : '')
  return { tab, query, sync, newSourceTag, newSourceKind }
})
